import { render, staticRenderFns } from "./UnitNerisId.vue?vue&type=template&id=16032b13&"
import script from "./UnitNerisId.vue?vue&type=script&lang=js&"
export * from "./UnitNerisId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports